import React from "react";
import { Link } from "react-router-dom";

export default function NewFooter() {
    const linkCls =
        "text-white/85 hover:text-[#fce503] hover:underline hover:decoration-[#fce503] hover:decoration-2 hover:underline-offset-4 transition-colors";

    return (
        <footer className="bg-black text-white">
            <div className="mx-auto max-w-[calc(100%-100px)] px-4 sm:px-8 lg:px-20 py-12">
                {/* Grid: 1ª más ancha */}
                <div className="grid gap-10 md:gap-12 grid-cols-1 md:grid-cols-[2fr,1fr,1fr,1fr]">
                    {/* Columna 1: Logo + texto + redes (centrados) */}
                    <div className="flex flex-col items-center text-center">
                        <img
                            src="/images/logos/logo-foot.png"
                            alt="Mano Ganadora"
                            className="mx-auto h-20 md:h-24 lg:h-28 w-auto mb-6"
                            draggable={false}
                        />

                        <p className="max-w-md text-white/85 leading-relaxed uppercase">
                            La plataforma digital definitiva para los juegos de cartas
                            tradicionales argentinos.
                        </p>

                        {/* Redes (mismo tamaño, centradas) */}
                        <div className="mt-6 flex justify-center items-center gap-5 text-[#fce503]">
                            <a href="#" aria-label="Instagram" className="hover:opacity-90 transition-opacity">
                                <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current align-middle">
                                    <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm10 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-5 3.5A5.5 5.5 0 1 1 6.5 13 5.51 5.51 0 0 1 12 7.5zm0 2A3.5 3.5 0 1 0 15.5 13 3.5 3.5 0 0 0 12 9.5zm5.75-3a1.25 1.25 0 1 1-1.25 1.25A1.25 1.25 0 0 1 17.75 6.5z" />
                                </svg>
                            </a>
                            <a href="#" aria-label="TikTok" className="hover:opacity-90 transition-opacity">
                                <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current align-middle">
                                    <path d="M16 2a6 6 0 0 0 5 5v3a8.98 8.98 0 0 1-5-1.6V15a7 7 0 1 1-7-7c.34 0 .67.03 1 .08V12a3 3 0 1 0 3 3V2h3z" />
                                </svg>
                            </a>
                            <a href="#" aria-label="X" className="hover:opacity-90 transition-opacity">
                                <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current align-middle">
                                    <path d="M3 3h3.5l5.1 7L16.9 3H21l-7.6 9.8L21 21h-3.6l-5.3-7.1L6.4 21H3l7.8-9.6L3 3z" />
                                </svg>
                            </a>
                            <a href="#" aria-label="YouTube" className="hover:opacity-90 transition-opacity">
                                <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current align-middle">
                                    <path d="M23 12s0-3.6-.5-5.3a3.2 3.2 0 0 0-2.2-2.2C18.6 4 12 4 12 4s-6.6 0-8.3.5A3.2 3.2 0 0 0 1.5 6.7C1 8.4 1 12 1 12s0 3.6.5 5.3c.3 1 1.1 1.9 2.2 2.2C5.4 20 12 20 12 20s6.6 0 8.3-.5a3.2 3.2 0 0 0 2.2-2.2c.5-1.7.5-5.3.5-5.3zM10 15.5v-7l6 3.5-6 3.5z" />
                                </svg>
                            </a>
                            <a href="#" aria-label="Discord" className="hover:opacity-90 transition-opacity">
                                <svg viewBox="0 0 24 24" className="w-7 h-7 fill-current align-middle">
                                    <path d="M20 4a18 18 0 0 0-4.2-1.3l-.2.4A15 15 0 0 1 12 3a15 15 0 0 1-3.6.1l-.2-.4A18 18 0 0 0 4 4C1.8 7.2 1 10.2 1 13.2a18 18 0 0 0 6.1 3.1l.8-1.2c-.4-.1-.8-.3-1.1-.5.1-.1.2-.1.3-.2a8 8 0 0 0 9.8 0l.3.2c-.4.2-.8.4-1.1.5l.8 1.2c2.3-.7 4.3-1.7 6.1-3.1C23 10.2 22.2 7.2 20 4Zm-11.4 9c-.8 0-1.4-.7-1.4-1.5S7.8 10 8.6 10s1.4.7 1.4 1.5S9.4 13 8.6 13Zm6.2 0c-.8 0-1.4-.7-1.4-1.5s.6-1.5 1.4-1.5 1.4.7 1.4 1.5-.6 1.5-1.4 1.5Z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Columna 2: Navegación + botón */}
                    <div>
                        <h4 className="text-[#fce503] font-extrabold uppercase tracking-wide mb-4">
                            Navegación
                        </h4>
                        <ul className="space-y-1 text-sm uppercase">
                            <li><a href="/games" className={linkCls}>Juegos</a></li>
                            <li><a href="#" className={linkCls}>Partidas Activas</a></li>
                            <li><a href="/next-games" className={linkCls}>Próximamente</a></li>
                            <li><a href="#" className={linkCls}>Nosotros</a></li>
                            <li><a href="#" className={linkCls}>Soporte</a></li>
                        </ul>

                        {/* Botón debajo */}
                        <div className="mt-6">
                            <Link
                                to="/register"
                                className="inline-block px-4 py-2 rounded-lg md:rounded-xl
                           text-xs md:text-sm font-extrabold uppercase tracking-wide
                           bg-[#2F86F6] hover:bg-[#4A99FF] text-white
                           shadow-sm hover:shadow transition-colors"
                            >
                                REGISTRARSE
                            </Link>
                        </div>
                    </div>

                    {/* Columna 3: Legal */}
                    <div>
                        <h4 className="text-[#fce503] font-extrabold uppercase tracking-wide mb-4">
                            Legal
                        </h4>
                        <ul className="space-y-1 text-sm uppercase">
                            <li><a href="/terms" className={linkCls}>Términos y condiciones.</a></li>
                            <li><a href="/terms" className={linkCls}>Políticas de privacidad.</a></li>
                            <li><a href="#" className={linkCls}>Juego responsable.</a></li>
                        </ul>
                    </div>

                    {/* Columna 4: Contacto + botón */}
                    <div>
                        <h4 className="text-[#fce503] font-extrabold uppercase tracking-wide mb-4">
                            Contacto
                        </h4>
                        <ul className="space-y-1 text-sm uppercase">
                            <li>
                                <span className="text-white/60">Email:</span>{" "}
                                <a href="mailto:soporte@manoganadora.com" className={linkCls}>
                                    soporte@manoganadora.com
                                </a>
                            </li>
                            <li>
                                <span className="text-white/60">Whatsapp:</span>{" "}
                                <br/><a href="#" className={linkCls}>+54 11 1234 - 5678</a>
                            </li>
                        </ul>

                        {/* Botón debajo */}
                        <div className="mt-6">
                            <Link
                                to="/chat"
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg
                           text-xs md:text-sm font-extrabold uppercase tracking-wide
                           bg-[#22c55e] hover:bg-[#16a34a] text-white
                           shadow-sm hover:shadow transition-colors"
                            >
                                <span className="text-white text-base leading-none">•</span>
                                CHAT EN VIVO DISPONIBLE
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}